module.exports = __webpack_public_path__ + "img/delete-icon.4e8c715e.svg";